// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FooterCard{\n    padding: 0.5rem 1rem;\n    text-align: center;\n}", "",{"version":3,"sources":["webpack://src/Components/FooterCard/FooterCard.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":[".FooterCard{\n    padding: 0.5rem 1rem;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
